// extracted by mini-css-extract-plugin
export default {"container":"TrainingMap_container__bmKp5"};